<template>
  <div class="social-media">
    <p class="heading d-block d-md-none">
      {{ $getTranslation("Connect with ResMed", $route.params.region) }}:
    </p>
    <ul>
      <li v-for="item in items">
        <a
          v-bind:href="item.href"
          target="_blank"
          v-bind:class="[item.name.toLowerCase().replace('.svg', '')]"
        ></a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "social-media",
  data() {
    return {
      items: [],
    };
  },
  created() {
    // get_field `social-media`
    let address = process.env.VUE_APP_API_ENDPOINT;
    const footerSocialLinks = `${address}/${
      this.$route.params.region
    }/wp-json/resmed/v1/navigation/footer-social-links`;
    axios.get(footerSocialLinks).then((response) => {
      this.items = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";

.social-media {
  margin-bottom: 1.25rem;
  .heading {
    font-family: "Plus Jakarta Sans", Arial, sans-serif;
    font-size: 14px;
  }

  ul {
    column-count: 1;
    display: flex;
    // justify-content: center;

    @media (min-width: 992px) {
      justify-content: flex-end;
    }

    li {
      &:first-child {
        margin-left: 0;
      }
      margin: 0 0.625rem;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  a {
    display: block;
    width: 1rem;
    height: 1rem;

    padding: 0;

    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;

    $items: (
      "linkedin",
      "facebook",
      "twitter",
      "youtube",
      "blogger",
      "codepen",
      "dribbble",
      "drive",
      "dropbox",
      "github",
      "googleplus",
      "hanghout",
      "instagram",
      "messenger",
      "pinterest",
      "skype",
      "slack",
      "tumblr",
      "twitter",
      "whatsapp"
    );

    @each $value in $items {
      &[class*="#{$value}"] {
        background-image: url(#{$assets}/images/social-media-icon-#{$value}.svg);
      }
    }
  }
}

footer.footer-product-review {
  .social-media {
    margin-bottom: 1rem;
    ul {
      @media (min-width: 992px) {
        justify-content: center;
      }
    }
  }
}
</style>
